import { EntityBase } from './EntityBase';
import { TypeLinkTarget } from './TypeLinkTarget';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class AnnouncementDetail extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   announcementDetailId: number;
   detailDescription: string;
   detailLink: string;
   announcementId: number;
   enabled: boolean;
   linkTargetType: string;
   tabOrdinal: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   typeLinkTarget: TypeLinkTarget;
}

